/**
 * Pipeline Widget
 *
 * Enhanced PipelineMonitor wrapped as a dashboard widget.
 * Shows the current pipeline state in compact mode.
 */

import { PipelineMonitor } from '../pipeline/PipelineMonitor';
import type { PipelineState } from '../../types/pipeline';

interface PipelineWidgetProps {
  pipelineState: PipelineState | null;
  noteStatus?: string;
}

export function PipelineWidget({
  pipelineState,
  noteStatus,
}: PipelineWidgetProps) {
  if (!pipelineState) {
    return (
      <div className="widget h-full flex flex-col">
        <div className="widget-header">
          <h3 className="text-xs font-semibold text-text-primary">
            Pipeline Status
          </h3>
        </div>
        <div className="widget-body flex-1 flex items-center justify-center">
          <p className="text-xs text-text-muted">
            Submit input to start pipeline
          </p>
        </div>
      </div>
    );
  }

  return (
    <PipelineMonitor
      pipelineState={pipelineState}
      noteStatus={noteStatus}
      compact={false}
      className="h-full"
    />
  );
}
